
import { defineComponent } from 'vue'
import { OptionCategory } from '@alao-frontend/core'
import OfferOptionsItemIcon from '~/components/offers/OfferOptions/OfferOptionsItemIcon.vue'
import IconInfo from '~/components/icons/IconInfo.vue'
import BenefitTooltip from '~/components/BenefitTooltip.vue'

export default defineComponent({
  name: 'OfferMainDetails',
  components: { BenefitTooltip, IconInfo, OfferOptionsItemIcon },
  props: {
    category: {
      type: String as () => OptionCategory,
      required: true,
    },
    title: {
      type: String,
      required: true,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
    tooltipContent: {
      type: String,
      default: '',
    },
    iconColor: {
      type: String,
      default: '#EE7F1A',
    },
    subOptions: {
      type: Array,
      default: () => [],
    },
    highlightOptions: {
      type: Boolean,
      default: false,
    },
  },
})
